// import React, { useState, useEffect, useRef, useCallback } from "react";
// import debounce from "lodash/debounce";

// interface OptionType {
//   id: number | string;
//   label: string;
// }

// interface DropdownProps {
//   placeholder?: string;
//   fetchRawData: (params: {
//     page: number;
//     limit: number;
//     search?: string;
//   }) => Promise<any>; // Parent provides API
//   formatOption: (item: any) => OptionType; // Parent provides formatter
//   includeAllOption?: boolean;
//   onChange: (id: string | number | null) => void;
//   value: string | number | null;
//   getById?: (id: string | number) => Promise<OptionType | null>;
//   DropdownLabel: string;
//   enabled?: boolean; // optional toggle
// }

// const CustomDropdown: React.FC<DropdownProps> = ({
//   placeholder,
//   fetchRawData,
//   formatOption,
//   includeAllOption = false,
//   onChange,
//   value,
//   getById,
//   DropdownLabel,
//   enabled = true,
// }) => {
//   const [options, setOptions] = useState<OptionType[]>([]);
//   const [search, setSearch] = useState("");
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const dropdownRef = useRef<HTMLDivElement>(null);
//   const limit = 10;

//   const fetchData = useCallback(
//     debounce(
//       async ({
//         page,
//         limit,
//         search,
//       }: {
//         page: number;
//         limit: number;
//         search: string;
//       }) => {
//         const rawData = await fetchRawData({ page, limit, search });
//         const rawList =
//           rawData?.data?.data?.data || rawData?.rowData?.data?.TownsData || [];

//         let formatted: OptionType[] = [];

//         if (Array.isArray(rawList)) {
//           formatted = rawList.map(formatOption);
//         } else if (typeof rawList === "object") {
//           formatted = Object.entries(rawList).map(([id, label]: any) =>
//             formatOption({ id, label })
//           );
//         }

//         formatted = formatted
//           .filter((option) => option.label)
//           .map((option) => ({ ...option, label: option.label.trim() }));

//         const finalData = includeAllOption
//           ? [{ id: "", label: "All" }, ...formatted]
//           : formatted;

//         const hasMoreResult = Array.isArray(rawList)
//           ? rawList.length === limit
//           : Object.keys(rawList).length === limit;

//         setOptions((prev) => [...prev, ...finalData]);
//         setHasMore(hasMoreResult);
//       },
//       400
//     ),
//     [fetchRawData, formatOption, includeAllOption]
//   );

//   const loadOptions = useCallback(() => {
//     if (!hasMore) return;
//     fetchData({ page, limit, search });
//   }, [page, search, hasMore, fetchData]);

//   useEffect(() => {
//     setOptions([]);
//     setPage(1);
//     setHasMore(true);
//   }, [search]);

//   useEffect(() => {
//     loadOptions();
//   }, [page, search]);

//   useEffect(() => {
//     if (value == null || options.find((opt) => opt.id === value)) return;

//     if (getById) {
//       getById(value).then((option) => {
//         if (option) {
//           setOptions((prev) => [...prev, option]);
//         }
//       });
//     }
//   }, [value, options, getById]);

//   const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
//     const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
//     if (scrollHeight - scrollTop <= clientHeight + 10 && hasMore) {
//       setPage((prev) => prev + 1);
//     }
//   };

//   const handleClickOutside = (event: MouseEvent) => {
//     if (
//       dropdownRef.current &&
//       !dropdownRef.current.contains(event.target as Node)
//     ) {
//       setShowDropdown(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   if (!enabled) return null;

//   return (
//     <div
//       ref={dropdownRef}
//       style={{
//         position: "relative",
//         display: "flex",
//         alignItems: "center",
//         gap: 8,
//       }}
//     >
//       <span
//         style={{
//           fontSize: 14,
//           color: "#2e8dd3",
//           fontWeight: 500,
//         }}
//       >
//         {DropdownLabel}
//       </span>

//       <button
//         onClick={() => setShowDropdown(!showDropdown)}
//         style={{
//           backgroundColor: "#2e8dd3",
//           color: "#fff",
//           fontWeight: "bold",
//           border: "none",
//           borderRadius: 20,
//           padding: "10px 10px",
//           display: "flex",
//           alignItems: "center",
//           gap: 6,
//           cursor: "pointer",
//           fontSize: 14,
//         }}
//       >
//         {options.find((opt) => opt.id === value)?.label ||
//           placeholder ||
//           "Select"}
//         <span style={{ fontSize: 10 }}>▼</span>
//       </button>

//       {showDropdown && (
//         <div
//           style={{
//             position: "absolute",
//             top: "calc(100% + 8px)",
//             right: 0,
//             width: 200,
//             maxHeight: 200,
//             overflowY: "auto",
//             backgroundColor: "#fff",
//             boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
//             borderRadius: 8,
//             zIndex: 999,
//           }}
//           onScroll={handleScroll}
//         >
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => {
//               setSearch(e.target.value);
//               setOptions([]);
//               setPage(1);
//             }}
//             style={{
//               width: "100%",
//               padding: "8px 10px",
//               border: "none",
//               borderBottom: "1px solid #ccc",
//               boxSizing: "border-box",
//               outline: "none",
//             }}
//           />
//           {options.length === 0 && (
//             <div style={{ padding: 10, textAlign: "center", color: "#666" }}>
//               No options found
//             </div>
//           )}
//           {options.map((option) => (
//             <div
//               key={option.id}
//               onClick={() => {
//                 onChange(option.id);
//                 setSearch("");
//                 setShowDropdown(false);
//               }}
//               style={{
//                 padding: "10px 12px",
//                 borderBottom: "1px solid #eee",
//                 cursor: "pointer",
//                 fontSize: 14,
//                 transition: "background-color 0.2s",
//               }}
//               onMouseEnter={(e) =>
//                 (e.currentTarget.style.backgroundColor = "#f0f0f0")
//               }
//               onMouseLeave={(e) =>
//                 (e.currentTarget.style.backgroundColor = "transparent")
//               }
//             >
//               {option.label}
//             </div>
//           ))}
//           {!hasMore && options.length > 0 && (
//             <div
//               style={{
//                 padding: 10,
//                 textAlign: "center",
//                 fontSize: 12,
//                 color: "#999",
//               }}
//             >
//               No more data
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default CustomDropdown;

import React, { useState, useEffect, useRef, useCallback } from "react";
import debounce from "lodash/debounce";
import { Spinner } from "reactstrap";

interface OptionType {
  id: number | string;
  label: string;
}

interface DropdownProps {
  placeholder?: string;
  fetchData: (params: {
    page: number;
    limit: number;
    search?: string;
  }) => Promise<{ data: OptionType[]; hasMore: boolean }>; // Already formatted data
  includeAllOption?: boolean;
  onChange: (id: string | number | null) => void;
  value: string | number | null;
  getById?: (id: string | number) => Promise<OptionType | null>;
  DropdownLabel: string;
  enabled?: boolean;
}

const CustomDropdown: React.FC<DropdownProps> = ({
  placeholder,
  fetchData,
  includeAllOption = false,
  onChange,
  value,
  getById,
  DropdownLabel,
  enabled = true,
}) => {
  const [options, setOptions] = useState<OptionType[]>([]);
  const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedOption, setSelectedOption] = useState<OptionType | null>(null);
  const [loading, setLoading] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const limit = 10;

  // const loadOptions = useCallback(
  //   debounce(async ({ page, limit, search }) => {
  //     const res = await fetchData({ page, limit, search });
  //     const formatted = includeAllOption && page === 1 ? res.data : res.data;

  //     setOptions((prev) => [...prev, ...formatted]);
  //     setHasMore(res.hasMore);
  //   }, 700),
  //   [fetchData, includeAllOption]
  // );

  const loadOptions = useCallback(
    debounce(async ({ page, limit, search }) => {
      setLoading(true); // ✅ Start loading
      try {
        const res = await fetchData({ page, limit, search });
        const formatted = includeAllOption && page === 1 ? res.data : res.data;

        setOptions((prev) => [...prev, ...formatted]);
        setHasMore(res.hasMore);
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      } finally {
        setLoading(false); // ✅ Stop loading
      }
    }, 1000),
    [fetchData, includeAllOption]
  );

  useEffect(() => {
    setOptions([]);
    setPage(1);
    setHasMore(true);
  }, [search]);

  useEffect(() => {
    loadOptions({ page, limit, search });
  }, [page, search]);

  useEffect(() => {
    if (value == null) {
      setSelectedOption(null);
      return;
    }

    const found = options.find((opt) => opt.id === value);
    if (found) {
      setSelectedOption(found);
      return;
    }

    if (getById) {
      getById(value).then((option) => {
        if (option) {
          setSelectedOption(option);
          setOptions((prev) => [...prev, option]);
        }
      });
    }
  }, [value, options, getById]);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - scrollTop <= clientHeight + 10 && hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!enabled) return null;

  return (
    <div
      ref={dropdownRef}
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      <span
        style={{
          fontSize: 14,
          color: "#2e8dd3",
          fontWeight: 500,
          // margin: "0px 8px",
        }}
      >
        {DropdownLabel}
      </span>

      <button
        onClick={() => setShowDropdown(!showDropdown)}
        style={{
          backgroundColor: "#2e8dd3",
          color: "#fff",
          fontWeight: "bold",
          border: "none",
          borderRadius: 20,
          padding: "10px 10px",
          display: "flex",
          alignItems: "center",
          gap: 8,
          cursor: "pointer",
          fontSize: 14,
        }}
      >
        {/* {options
          ? options.find((opt) => opt.id == value)?.label
          : placeholder || "Select"} */}
        {selectedOption?.label || placeholder || "Select"}

        <span
          style={{
            display: "inline-block",
            transition: "transform 0.3s",
            transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
            marginLeft: "5px",
            fontSize: "10px",
          }}
        >
          ▼
        </span>
      </button>

      {showDropdown && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 8px)",
            right: 0,
            width: 200,
            maxHeight: 200,
            overflowY: "auto",
            backgroundColor: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            borderRadius: 8,
            zIndex: 999,
          }}
          onScroll={handleScroll}
        >
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setOptions([]);
              setPage(1);
            }}
            style={{
              width: "100%",
              padding: "8px 10px",
              border: "none",
              borderBottom: "1px solid #ccc",
              boxSizing: "border-box",
              outline: "none",
            }}
          />

          {options.map((option) => (
            <div
              key={option.id}
              onClick={() => {
                onChange(option.id);
                setSelectedOption(option); // <-- ✅ Set manually
                setSearch("");
                setShowDropdown(false);
              }}
              style={{
                padding: "4px 12px",
                borderBottom: "1px solid #eee",
                cursor: "pointer",
                fontSize: 14,
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#f0f0f0")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              {option.label}
            </div>
          ))}
          {loading && (
            <div
              style={{
                padding: 10,
                textAlign: "center",
                fontSize: 12,
                color: "#666",
              }}
            >
              <Spinner
                color="primary"
                style={{ width: "1rem", height: "1rem" }}
              />
            </div>
          )}
          {options.length === 0 && (
            <div style={{ padding: 10, textAlign: "center", color: "#666" }}>
              No options found
            </div>
          )}
          {!hasMore && options.length > 0 && (
            <div
              style={{
                padding: 10,
                textAlign: "center",
                fontSize: 12,
                color: "#999",
              }}
            >
              No more data
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
